import React, { useState, useEffect } from "react";
import "./Assurance.css";
import { useNavigate } from "react-router-dom";
import logo from "./media/logo.png";
import QRCode from "./media/qr_code.svg";
import HandshakeAnimation from "./HandshakeAnimation"; 

const NAV_ITEMS = [ { label: "About Us", path: "/about", type: "page" }, { label: "Our Team", path: "/team", type: "page" }, { label: "Services", path: "/#services", type: "scroll" }, { label: "Contact", path: "/contact", type: "page" } ];

function Assurance() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (item) => {
    setMenuOpen(false);
    if (item.type === "scroll") {
        navigate("/");
        setTimeout(() => { document.querySelector(item.path.replace("/", "")).scrollIntoView({ behavior: "smooth" }); }, 100);
    } else {
        navigate(item.path);
        window.scrollTo(0, 0);
    }
  };

  return (
    <div className="App assurance-page-wrapper">
      <div className={`dimming-overlay ${menuOpen ? "active" : ""}`} onClick={() => setMenuOpen(false)}></div>
      <header className={`App-header ${scrolled ? "scrolled" : ""}`}>
        <a className="logo" href="/" onClick={(e) => { e.preventDefault(); navigate("/"); }}><img src={logo} alt="Logo" className="header-logo" /></a>
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}><div className="bar"></div><div className="bar"></div><div className="bar"></div></div>
      </header>
      <nav className={`dropdown-menu ${menuOpen ? "open" : ""}`}>
        <ul>{NAV_ITEMS.map((item, i) => <li className="dropdown-item" key={i}><a onClick={() => handleNav(item)}>{item.label}</a></li>)}</ul>
      </nav>

      <section className="assurance-hero">
        <div className="container">
          <h1>Quality Assurance</h1> 
          <div className="assurance-divider"></div>
        </div>
      </section>

      <section className="section white-bg">
        <div className="container split-layout">
          <div className="text-content">
            <h2>Client Services Supervision</h2>
            <p>
              In alignment with our mission to deliver high-quality services, we have established a Client Services Supervision (CSS) department. This department is dedicated to maintaining close communication with clients, addressing complaints regarding service delivery, and handling requests promptly.
            </p>
            <p>Additionally, the firm boasts a comprehensive legal library, providing valuable resources to support our partners.</p>
          </div>
          <div className="animation-content">
             <HandshakeAnimation />
          </div>
        </div>
      </section>

      <footer className="App-footer">
        <div className="qr-box"><img src={QRCode} alt="QR" /></div>
        <p>© 2025 MERKEL & ASSOCIATES ADVOCATES.</p>
      </footer>
    </div>
  );
}
export default Assurance;